export enum HttpCode {
  UNPROCESSABLE_ENTITY_ERROR = 422,
  PRECONDITION_FAILED_ERROR = 412,
  UNAUTHORIZED_ERROR = 401,
  REQUEST_TIMEOUT_ERROR = 408,
  FORBIDDEN_ERROR = 403,
  SUCCESS = 200  
}